// extracted by mini-css-extract-plugin
module.exports = {"benefit":"_de16b7d","icon":"_c02383c1","text":"_fc2d8417"};